import { Injectable } from '@angular/core';
import { QuotationCommercialItem } from 'projects/dop-ordering/src/lib/models/quotable-items/quotation-commercial-item.model';
import { CommercialItemValidationResponse } from '../../models/commercial-item-validation-response.model';

@Injectable({
    providedIn: 'root'
})
export class FreeTestPlanningLineRule {

    constructor(private quotationCommercialItem: QuotationCommercialItem) { }

    validateTest(testCode: string, quotationLineCode: string): CommercialItemValidationResponse {
        const freeTest = this.quotationCommercialItem?.freeQuotationLinesTest
            .filter(x => x.testCode === testCode && x.code === quotationLineCode).shift();

        return {
            data: freeTest,
            isValid: freeTest !== undefined,
        };
    }
}
